import { ChevronDown } from "lucide-react";
import React from "react";

import { useTheme } from "@mui/material";

import { IgCustomTheme } from "./theme";

export const IgIconComponent = (props: any) => {
  const theme = useTheme();
  return (
    <ChevronDown
      size={16}
      className={props.className}
      color={props.color ?? (theme as IgCustomTheme).igIconColors.light}
      {...props}
    />
  );
};
